import React from "react";
import { withRouter } from "react-router-dom";
import { Route } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import Settings from "../components/Settings";
import ViewProfile from "../components/ViewProfile";
import UpdateInfoContainer from "../containers/UpdateInfo";
class SettingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      isLoading: true,
      currentUser: [],
      transporters: [],
      organisations: [],
      bardanaCondition: [],
      dealQuality: [],
      dispatchCondition: []
    };
  }
  componentWillMount() {
    this.fetchProducts();
    this.fetchUnits();
    this.fetchCustomers();
    this.fetchCurrentUser();
    this.fetchTransporters();
    this.fetchOrganisations();
    this.fetchBardanaCondition();
    this.fetchDispatchCondition();
    this.fetchDealQuality();
  }
  fetchCurrentUser = () => {
    this.props.db
      .collection("users")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const currentUser = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleCustomer = doc.data();
            singleCustomer.id = doc.id;
            currentUser.push(singleCustomer);
          }
        });
        this.setState({ currentUser, isLoading: false });
      });
  };

  fetchCustomers = () => {
    this.props.db
      .collection("customers")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const customers = [];
        querySnapshot.forEach(doc => {
          const singleCustomer = doc.data();
          singleCustomer.id = doc.id;
          singleCustomer.value = doc.id;
          singleCustomer.label = doc.data().name;
          customers.push(singleCustomer);
        });
        this.setState({ customers, isLoading: false });
      });
  };
  fetchUnits = () => {
    this.props.db
      .collection("units")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const units = [];
        querySnapshot.forEach(doc => {
          const singleUnit = doc.data();
          singleUnit.id = doc.id;
          units.push(singleUnit);
        });
        this.setState({ units, isLoading: false });
      });
  };
  fetchBardanaCondition = () => {
    this.props.db
      .collection("bardanaCondition")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const bardanaCondition = [];
        querySnapshot.forEach(doc => {
          const singleBardanaCondition = doc.data();
          singleBardanaCondition.id = doc.id;
          bardanaCondition.push(singleBardanaCondition);
        });
        this.setState({ bardanaCondition, isLoading: false });
      });
  };
  fetchDispatchCondition = () => {
    this.props.db
      .collection("dispatchCondition")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const dispatchCondition = [];
        querySnapshot.forEach(doc => {
          const singleDispatchCondition = doc.data();
          singleDispatchCondition.id = doc.id;
          dispatchCondition.push(singleDispatchCondition);
        });
        this.setState({ dispatchCondition, isLoading: false });
      });
  };
  fetchDealQuality = () => {
    this.props.db
      .collection("dealQuality")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const dealQuality = [];
        querySnapshot.forEach(doc => {
          const singleDealQuality = doc.data();
          singleDealQuality.id = doc.id;
          dealQuality.push(singleDealQuality);
        });
        this.setState({ dealQuality, isLoading: false });
      });
  };
  fetchTransporters = () => {
    this.props.db
      .collection("transporters")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const transporters = [];
        querySnapshot.forEach(doc => {
          const singleTransporter = doc.data();
          singleTransporter.id = doc.id;
          transporters.push(singleTransporter);
        });
        this.setState({ transporters, isLoading: false });
      });
  };
  fetchProducts = () => {
    this.props.db
      .collection("products")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const products = [];
        querySnapshot.forEach(doc => {
          const singleProduct = doc.data();
          singleProduct.id = doc.id;
          products.push(singleProduct);
        });
        this.setState({ products, isLoading: false });
      });
  };
  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
      });
  };
  addUnit = unit => {
    this.props.db.collection("units").add(unit);
  };
  addProduct = product => {
    this.props.db.collection("products").add(product);
  };
  addTransporter = transporter => {
    this.props.db.collection("transporters").add(transporter);
  };
  addBardanaCondition = bardanaConditon => {
    this.props.db.collection("bardanaCondition").add(bardanaConditon);
  };
  addDealQuality = dealQuality => {
    this.props.db.collection("dealQuality").add(dealQuality);
  };
  addDispatchConditon = dispatchCondition => {
    this.props.db.collection("dispatchCondition").add(dispatchCondition);
  };
  render() {
    const {
      customers,
      products,
      units,
      currentUser,
      transporters,
      organisations,
      bardanaCondition,
      dealQuality,
      dispatchCondition
    } = this.state;
    const { user } = this.props;
    return (
      <div>
        <Route
          exact
          path="/settings"
          render={props => (
            <Settings
              user={user}
              customers={customers}
              products={products}
              units={units}
              transporters={transporters}
              addTransporter={this.addTransporter}
              addUnit={this.addUnit}
              addProduct={this.addProduct}
              id={this.props.match.params.id}
              logOut={this.props.firebase.logOut}
              currentUser={currentUser}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
              bardanaCondition={bardanaCondition}
              dealQuality={dealQuality}
              dispatchCondition={dispatchCondition}
              addBardanaCondition={this.addBardanaCondition}
              addDealQuality={this.addDealQuality}
              addDispatchConditon={this.addDispatchConditon}
            />
          )}
        />
        <Route
          exact
          path="/settings/viewProfile"
          render={props => (
            <ViewProfile
              user={user}
              logOut={this.props.firebase.logOut}
              currentUser={currentUser}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
        <Route
          exact
          path="/settings/updateInfo"
          render={props => (
            <UpdateInfoContainer
              user={user}
              logOut={this.props.firebase.logOut}
              currentUser={currentUser}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(SettingContainer)));
